<template>
 <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">{{form_title}}</h1>
              <p class="text-lead text-white">{{message}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <!-- Table -->
      <div class="row justify-content-center">
        <div class="col-lg-10">
        
        		<card v-if="completed_form==1" style="text-align:center;" >
          			<div class="card-body" style="text-align:left;font-size:24px;text-align:center;padding-top:50px;padding-bottom:50px">
          				Your submission is complete. Thank You.
          			</div>
          		</card>
          			
          		<card v-if="form_loaded==1" style="min-height:350px;min-width:300px;text-align:center;" >
          			<div class="card-body" style="text-align:left;font-size:14px;">
          				
          				<div >
          					Date of notice: <strong>{{cf.created_at_str}}</strong>
          				</div>
          				<br/>
          				
          				<div  v-if="cf.is_company==1">
          					Dear <strong>{{cf.company.entity_name}}</strong>,
          				</div>
          				<div  v-if="cf.is_company!=1">
          					Dear <strong>{{cf.person_name}}</strong>,
          				</div>
          				
          				
          				<br/>
          				<br/>
          				
          				<div style="margin-bottom:60px">
          					We know or have reasonable grounds to believe that you are a registrable controller of <strong>{{cf.entity_name}}</strong>.
          					<br/><br/>
							This notice is sent under section 386AG(2)(a) of the Companies Act (Cap. 50) and requires you to 
							provide the following information within 30 days after the date of this notice. 
							Please submit the form as soon as you can. 
							Failure to provide the information required by this notice may be an offence.
				
          				</div>
          				
          				
          				
          				<div style="margin-top:30px;">
          					<div class="row">
    				  	 <div class="col-xl-10" style="margin-top:20px;"> 
    				  		
    				  		<div v-if="cf.is_company!=1" style="font-weight:bold;margin-bottom:10px;"> Are you a registrable controller of {{cf.entity_name}}?</div>
    				  		<div v-if="cf.is_company==1" style="font-weight:bold;margin-bottom:10px;"> Are you ({{cf.company.entity_name}}) a registrable controller of {{cf.entity_name}}?</div>
    				  		
    				  		
							 <base-input label=""
							 			 name="im_controller" :rules="{required: true}">
							  <el-select v-model="new_info.im_controller" 
										 placeholder="Select">
								<el-option v-for="option in selects.yesno"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
    				
					 	</div>
				
    				  
    				  </div> <!-- end row -->
          			</div>
             		<!-- end im controller -->
             		
             			<!-- start corporate controller -->
             			<div v-if="cf.is_company==1">
             			
             			 <!-- start field -->
             			 <div style="margin-top:50px;">
							<span class="h6 surtitle">Your Entity Name</span> 
							<div class="h3 ">{{cf.company.entity_name}}</div>
							
							<div v-if="new_entity_name_form==0" @click="displayNewEntityNameForm" style="color:green;font-size:12px;cursor:pointer">(Update Your Entity Name)</div>
							
							
							<div v-if="new_entity_name_form==1" class="row" style="">
					 	 		<div class="col-xl-5" style="margin-top:20px;"> 
					 	 				<base-input prepend-icon="fas fa-user" label="New Entity Name"   name="entity name" v-model="new_info.entity_name"/>

					 	 		</div>
					 	 		
					 	 	</div>
					 	 	<div v-if="new_entity_name_form==1" @click="hideNewEntityNameForm" style="color:red;font-size:12px;cursor:pointer">(Remove)</div>

							

						 </div>
						 <!-- end field -->
						 
						 
						  <!-- start field -->
             			 <div style="margin-top:50px;">
							<span class="h6 surtitle">Your Unique Entity Number (Issued by the Registrar)</span> 
							<div class="h3 ">{{cf.company.company_reg_num}}</div>
							
							<div v-if="new_company_reg_num_form==0" @click="displayNewCompanyRegNumForm" style="color:green;font-size:12px;cursor:pointer">(Update Your Unique Entity Number)</div>
							
							
							<div v-if="new_company_reg_num_form==1" class="row" style="">
					 	 		<div class="col-xl-5" style="margin-top:20px;"> 
					 	 				<base-input prepend-icon="fas fa-user" label="New Unique Entity Number"   name="unique entity number" v-model="new_info.company_reg_num"/>

					 	 		</div>
					 	 		
					 	 	</div>
					 	 	<div v-if="new_company_reg_num_form==1" @click="hideNewCompanyRegNumForm" style="color:red;font-size:12px;cursor:pointer">(Remove)</div>

							

						 </div>
						 <!-- end field -->
						 
						 
						 <!-- start field -->
             			 <div style="margin-top:50px;">
							<span class="h6 surtitle">Address Of Registered Office</span> 
							<div class="h3 ">{{cf.company.entity_address}}</div>
							
							<div v-if="new_entity_address_form==0" @click="displayNewEntityAddressForm" style="color:green;font-size:12px;cursor:pointer">(Update Your Office Address)</div>
							
							
							<div v-if="new_entity_address_form==1" class="row" style="">
					 	 		<div class="col-xl-5" style="margin-top:20px;"> 
					 	 				<base-input prepend-icon="fas fa-user" label="New Registered Office Address"   name="entity address" v-model="new_info.entity_address"/>

					 	 		</div>
					 	 		
					 	 	</div>
					 	 	<div v-if="new_entity_address_form==1" @click="hideNewEntityAddressForm" style="color:red;font-size:12px;cursor:pointer">(Remove)</div>

							

						 </div>
						 <!-- end field -->
						 
						 
						 <!-- start field -->
             			 <div style="margin-top:50px;">
							<span class="h5 ">Your legal form</span> 
							
							<div class="col-xl-5" style="margin-top:8px;margin-left:-15px;"> 
					 	 				<base-input label=""   name="legal form" v-model="new_info.legal_form"/>
					 	 		</div>
	
						 </div>
						 <!-- end field -->
						 
						 
						  <!-- start field -->
             			 <div style="margin-top:50px;">
							<span class="h5 ">The jurisdiction where, and statute under which, you are formed or incorporated</span> 
							
							<div class="col-xl-5" style="margin-top:8px;margin-left:-15px;"> 
					 	 				<base-input label=""  name="jurisdiction" v-model="new_info.jurisdiction"/>
					 	 		</div>
	
						 </div>
						 <!-- end field -->
             			
             			
             			  <!-- start field -->
             			 <div style="margin-top:50px;">
							<span class="h5 ">The name of the corporate entity register of the jurisdiction in which you are formed or incorporated (if applicable)</span> 
							
							<div class="col-xl-5" style="margin-top:8px;margin-left:-15px;"> 
					 	 				<base-input label=""  name="corporate entity register" v-model="new_info.corporate_entity_register"/>
					 	 		</div>
	
						 </div>
						 <!-- end field -->
						 
						 
						  <!-- start field -->
             			 <div style="margin-top:50px;">
							<span class="h5 ">The identification number or registration number on the corporate entity register of the jurisdiction where you are formed or incorporated (if applicable)</span> 
							
							<div class="col-xl-5" style="margin-top:8px;margin-left:-15px;"> 
					 	 				<base-input label=""  name="corporate entity register reg num" v-model="new_info.corporate_entity_register_id_num"/>
					 	 		</div>
	
						 </div>
						 <!-- end field -->
             			
             			
             			
             			
             			 </div>
             			<!-- end corporate controller -->
             			
             			
             			
             		
             			<!-- start individual controller -->
          				<div v-if="cf.is_company!=1">
          				  <div style="margin-top:50px;">
							<span class="h6 surtitle">Your Full Name</span> 
							<div class="h3 ">{{cf.person_name}}</div>
							
							<div v-if="new_name_form==0" @click="displayNewNameForm" style="color:green;font-size:12px;cursor:pointer">(Update Your Name)</div>
							
							
							<div v-if="new_name_form==1" class="row" style="">
					 	 		<div class="col-xl-5" style="margin-top:20px;"> 
					 	 				<base-input prepend-icon="fas fa-user" label="New First Name"   name="first name" v-model="new_info.first_name"/>

					 	 		</div>
					 	 		<div class="col-xl-5" style="margin-top:20px;"> 
					 	 				<base-input prepend-icon="fas fa-user" label="New Last Name"   name="last name" v-model="new_info.last_name"/>

					 	 		</div>
					 	 		
					 	 	</div>
					 	 	<div v-if="new_name_form==1" @click="hideNewNameForm" style="color:red;font-size:12px;cursor:pointer">(Remove)</div>

							

						 </div>
						 
						  <!-- end name -->
						  
						  
						   <div style="margin-top:50px;">
             			  	<div class="row" style="">
								<div class="col-xl-5" style="margin-top:20px;"> 
									<base-input prepend-icon="fas fa-user" label="Your Aliases (if any)"   name="alias" v-model="new_info.alias"/>
          				  		</div>
          				  	</div>
          				  
          				   </div>
             			 	<!-- end alias -->
             			 	
             			 	
             			 	
						 
						  <div style="margin-top:50px;">
							<span class="h6 surtitle">Your Residential Address</span>
							<div class="h3 ">{{cf.person_address}}</div>
							
							
							<div v-if="new_address_form==0" @click="displayNewAddressForm" style="color:green;font-size:12px;cursor:pointer">(Update Your Address)</div>

							<div v-if="new_address_form==1" class="row" style="">
					 	 		<div class="col-xl-9" style="margin-top:20px;"> 
					 	 				<base-input prepend-icon="fas fa-user" label="New Address"   name="address" v-model="new_info.address"/>

					 	 		</div>
					 	
					 	 		
					 	 	</div>
					 	 	<div v-if="new_address_form==1" @click="hideNewAddressForm" style="color:red;font-size:12px;cursor:pointer">(Remove)</div>

							
							
						 </div>
             			 <!-- end address -->
             			 
             			 
             			 
             			 
          				
          				
          				 <div style="margin-top:50px;">
          				 	<span class="h6 surtitle">Your Nationality</span>
							<div class="h3 ">{{cf.person_nationality}}</div>
          				 
          				 
          				 
             			  	<div v-if="new_nationality_form==0" @click="displayNewNationalityForm" style="color:green;font-size:12px;cursor:pointer">(Update Your Nationality)</div>

							<div v-if="new_nationality_form==1" class="row" style="">
					 	 		<div class="col-xl-9" style="margin-top:20px;"> 
					 	 				<base-input  label="New Nationality"   name="nationality" v-model="new_info.nationality"/>

					 	 		</div>
					 	
					 	 		
					 	 	</div>
					 	 	<div v-if="new_nationality_form==1" @click="hideNewNationalityForm" style="color:red;font-size:12px;cursor:pointer">(Remove)</div>

          				  
          				   </div>
             			 	<!-- end nationality -->
          				
          				
          				
          				<div style="margin-top:50px;">
							<span class="h6 surtitle">Identity Card or Passport Number</span>
							<div class="h3 ">{{cf.person_gov_id}}</div>
							
							
							<div v-if="new_id_no_form==0" @click="displayNewIdNoForm" style="color:green;font-size:12px;cursor:pointer">(Update Your ID No.)</div>

							<div v-if="new_id_no_form==1" class="row" style="">
					 	 		<div class="col-xl-9" style="margin-top:20px;"> 
					 	 				<base-input prepend-icon="fas fa-user" label="New Identity Card or Passport Number"   name="address" v-model="new_info.gov_id"/>

					 	 		</div>
					 	
					 	 		
					 	 	</div>
					 	 	<div v-if="new_id_no_form==1" @click="hideNewIdNoForm" style="color:red;font-size:12px;cursor:pointer">(Remove)</div>

							
							
						 </div>
             			 <!-- end gov id -->
             			 
          				
          				 <div style="margin-top:50px;">
             			  	<div class="row" style="">
								<div class="col-xl-5" style="margin-top:20px;"> 
								
								<base-input label="Date Of Birth" :rules="{required: true}"  name="date of birth" >
								<flat-picker slot-scope="{focus, blur}"
											 @on-open="focus"
											 @on-close="blur"
											 :config="{allowInput: true}"
											 class="form-control datepicker"
											 v-model="new_info.dob">
								</flat-picker>
                     		 </base-input>
                     		 
                     		 
          				  		</div>
          				  	</div>
          				  
          				   </div>
             			 	<!-- end date of birth -->
             			 	
             			 	</div>
             			 	<!-- end individual controller -->
             			 	
             			 	
             			 	<div style="margin-top:30px;">
             			  	<div class="row" style="">
								<div class="col-xl-7" style="margin-top:20px;"> 
								
								<base-input label="Date On Which You Became A Controller"  name="date controller" >
								<flat-picker slot-scope="{focus, blur}"
											 @on-open="focus"
											 @on-close="blur"
											 :config="{allowInput: true}"
											 class="form-control datepicker"
											 v-model="new_info.date_controller">
								</flat-picker>
								 
                     		 </base-input>
                     			<div>* Leave empty if you do not know the exact date</div>
                     		 
          				  		</div>
          				  	</div>
          				  
          				   </div>
             			 	<!-- end date of controller -->
          				
          				
          				
          				
          				<div style="margin-top:30px;">
          					<div class="row">
    				  	 <div class="col-xl-10" style="margin-top:20px;"> 
							 <base-input label="Do you know or have reasonable grounds to believe that any other person is a registrable controller or is likely to have that knowledge?"
							 			 name="know_controller" :rules="{required: true}">
							  <el-select v-model="new_info.know_controller" 
							  			 @change="onKnowControllerChange($event)"
										 placeholder="Select">
								<el-option v-for="option in selects.yesno"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
    				
					 	</div>
				
    				  
    				  </div> <!-- end row -->
          			</div>
             		<!-- end know controller -->
          				
          				
          			<div style="margin-top:20px;">	
          				<div v-if="new_info.know_controller==1" class="row">
    				  	 <div class="col-xl-12" style="margin-top:20px;"> 
    				  	 	<div>
    				  	 	 If yes, please provide us the following information regarding the controller:
    				  	 	 <br/><br/>
    				  	 	 
    				  	 	 <strong>For Individuals</strong>
    				  	 	 <ul>
    				  	 	 	<li>Full name</li>
    				  	 	 	<li>The person's aliases, if any</li>
    				  	 	 	<li>Residential Address</li>
    				  	 	 	<li>Nationality</li>
    				  	 	    <li>Identity card number of passport number</li>
    				  	 	    <li>Date of birth</li>
    				  	 	     <li>Date on which person became an individual controller of {{cf.entity_name}}</li>
    				  	 	 </ul>
    				  	 	 
    				  	 	 <br/>
    				  	 	  <strong>For Legal Entities (e.g. companies)</strong>
    				  	 	 <ul>
    				  	 	 	<li>Entity name</li>
    				  	 	 	<li>Unique entity number issued by the Registrar, if any</li>
    				  	 	 	<li>Registered Address</li>
    				  	 	 	<li>Legal form (e.g. private limited company)</li>
    				  	 	    <li>Jurisdiction where, and the statute under which, the entity is formed or incorporated</li>
    				  	 	    <li>Name of the corporate entity register of the jurisdiction in which the entity is formed or incorporated</li>
    				  	 	     <li>Date on which entity became a corporate controller of {{cf.entity_name}}</li>
    				  	 	 </ul>
    				  	 
    				  	 	</div>
    				  	 		 <br/><br/>
							 	<base-input >
                   					 <textarea class="form-control" v-model="new_info.know_controller_info" rows="6"></textarea>
                  				</base-input>	
					 	</div>
		
    				  
    				  </div> <!-- end row -->
          			</div>
             	<!-- end know controller form -->
          				
          				
          				
          				 <base-button block type="primary" style="padding-bottom:20px;padding-top:20px;margin-top:50px" 
          				 @click="submitComplianceForm">I confirm that the details provided above are correct</base-button>
          		
          			</div>
          		</card>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  import { Select, Option } from 'element-ui'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  
  
   
 export default {
    components: {
  		 [Select.name]: Select,
     	 [Option.name]: Option,
     	 flatPicker
    },
    data() {
      return {
      	 form_loaded: 0,
      	 completed_form: 0,
      	 form_title: 'Notice For Controllers',
      	 message: 'Retrieving your information ...',
     	 cf:[],
     	 new_info:{
     	 	know_controller:0,
     	 	im_controller:1,
     	 },
     	 new_name_form: 0,
     	 new_entity_name_form: 0,
     	 new_company_reg_num_form : 0,
     	 new_entity_address_form: 0,
     	 new_address_form:0,
     	 new_nationality_form:0,
     	 new_id_no_form:0,
     	 new_know_controller_form:0,
     	 selects: {          
		   yesno: [
         	  {value: 1, label: 'Yes'},
             {value: 0, label: 'No'},
		   ],
		  },
	
      };
    },
    methods: {
   	  displayNewEntityNameForm(){
   	  	this.new_entity_name_form = 1;
   	  },
      displayNewNameForm() {
			this.new_name_form = 1;
      },
      hideNewEntityNameForm(){
        this.new_entity_name_form = 0;
        if(this.new_info.entity_name){
        	this.new_info.entity_name = "";
        }
      },
      displayNewCompanyRegNumForm(){
      	this.new_company_reg_num_form = 1;
      },
      hideNewCompanyRegNumForm(){
         this.new_company_reg_num_form = 0;
         if(this.new_info.company_reg_num){
      	 	this.new_info.company_reg_num = "";
      	 }
      },
       displayNewEntityAddressForm(){
      	this.new_entity_address_form = 1;
      },
      hideNewEntityAddressForm(){
      	this.new_entity_address_form = 0;
      	if(this.new_info.entity_address){
      		this.new_info.entity_address = "";
      	}
      },
      hideNewNameForm(){
      		this.new_name_form = 0;
      		if(this.new_info.first_name){
      			this.new_info.first_name = "";
      		}
      		if(this.new_info.last_name){
      			this.new_info.last_name = "";
      		}
      },
      displayNewAddressForm(){
      		this.new_address_form = 1;
      },
      hideNewAddressForm(){
      		this.new_address_form = 0;
      		if(this.new_info.address){
      			this.new_info.address = "";
      		}
      },
      displayNewNationalityForm(){
      		this.new_nationality_form = 1;
      },
      hideNewNationalityForm(){
      		this.new_nationality_form = 0;
      		if(this.new_info.nationality){
      			this.new_info.nationality = "";
      		}
      },
      displayNewIdNoForm(){
      		this.new_id_no_form = 1;
      },
      hideNewIdNoForm(){
      		this.new_id_no_form = 0;
      		if(this.new_info.gov_id){
      			this.new_info.gov_id = "";
      		}
      },
      onKnowControllerChange(){
      		if(this.new_info.know_controller==1){
      			this.new_know_controller_form = 1;
      		}
      },
      submitComplianceForm(){
      		if(this.cf.is_company!=1 && !this.new_info.dob){
      		
      			swal.fire({
						title: `Oops`,
						text: "Please enter your date of birth.",
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-warning',
						icon: 'warning'
					 })
      		
      		}
      		else if(this.cf.is_company==1 && !this.new_info.jurisdiction){
      		
      			swal.fire({
						title: `Oops`,
						text: "Please enter the jurisdiction where, and statute under which, you are formed or incorporated.",
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-warning',
						icon: 'warning'
					 })
      		
      		}
      		else{

				this.form_loaded = 0;
				swal.showLoading();
				let uri = this.$base_url+'/api/v1/c/submit_compliance_form';
				 ApiService.post(uri, this.new_info).then(response => {
					if(response.data.message=="Unauthorized"){
						swal.fire({
								title: `Oops`,
								text: "You seem to be submitting an unauthorized form. Please click on the unique link sent to you or contact your account manager.",
								buttonsStyling: false,
								confirmButtonClass: 'btn btn-warning',
								icon: 'warning'
							  })
					}
					else{
				
						 this.completed_form = 1;
						 swal.close();
					}
				
				})//end post
      	
      	}//end if-else
      }
    },
    mounted() {
      	swal.showLoading();
      	let uri = this.$base_url+'/api/v1/c/get-compliance-form/'+ this.$route.params.cfid + "/"+this.$route.params.sig;
      	
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 
			 this.cf = response.data.cf;
			 this.form_loaded = 1;
			 this.message = this.cf.entity_name+" ("+this.cf.uen+")";
			 this.new_info.cfid = this.$route.params.cfid;
			 this.new_info.sig = this.$route.params.sig;
			 
      		 swal.close();
   
      	})
      	
      	
    }
  };
</script>
<style>
</style>
